// Registering a runner, as the pages see it (runners/registration.rs on the
// server). A person makes a one-time code with a fresh passkey confirmation
// of the action `register_runner`, whose digest is the SHA-256 of the empty
// string: the confirmation names its person and its workspace itself, and the
// code approves one new runner there, so the digest has nothing more to bind.
// On the runner's machine, `dev/serve runner` asks for the code, and trades it
// for the runner's token.
import type { ConfirmAction } from '../api/types'

/** What a person confirms to make a runner's code: `register_runner`, and the SHA-256 of the empty string. */
export const REGISTER_RUNNER: ConfirmAction = {
  kind: 'register_runner',
  digest: 'e3b0c44298fc1c149afbf4c8996fb92427ae41e4649b934ca495991b7852b855',
}
